<template>
  <!-- 转岗 -->
  <div class="assignPage"  v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-cell title="申请人" required v-model="userinfo.realName" class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell title="原部门" v-model="userinfo.departmentName" class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell title="原职位" v-model="userinfo.positionName" class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="转入部门"
        required
        v-model="upDepartment"
        @click="showDepartmentPicker = true"
        is-link
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="转入职位"
        required
        v-model="upPost"
        @click="showPostPicker = true"
        is-link
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell
        title="生效日期"
        required
        v-model="startDate"
        @click="TimePicker"
        is-link
        class="ggInput"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary summaryBox">
      <van-cell title="转岗原因：" readonly class="readonlyInpt" />
      <van-field
        v-model="reason"
        rows="2"
        autosize
        type="textarea"
        placeholder="请填写转岗原因"
        class="summary"
      />
    </van-cell-group>
    <div class="btnBox">
      <a href="javascript:void(0);" class="btn" @click="saveAssign">保存</a>
    </div>
    <!-- 弹出层 -->
    <!-- 职位选择器 -->
    <van-popup v-model="showPostPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="postList"
        value-key="dictName"
        @cancel="showPostPicker = false"
        @confirm="savePost"
      />
    </van-popup>
    <!-- 部门选择器 -->
    <van-popup v-model="showDepartmentPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="departmentList"
        value-key="departmentName"
        @cancel="showDepartmentPicker = false"
        @confirm="saveDepartment"
      />
    </van-popup>
    <!-- 时间选择器 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="closeTimePicker"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
import {
  dateFormat,
  getDictList,
  getDepartment,
  getURLParam
} from "@/utils/common";
 
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "assignOffice",
  data() {
    return {
      commonId: "", //申请Id
      baseData:{},
      upDepartment: "", //即将到任部门
      upPost: "", //即将到任职位
      showDepartmentPicker: false,
      departmentList: [], //部门列表
      showPostPicker: false,
      postCode: "gangwei",
      postList: [], //职位列表
      showTimePicker: false, //时间选择控件
      currentDate: new Date(), //当前时间
      minDate: new Date(2000, 1, 1),
      startDate: "",
      reason: "", //转岗原因
      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType() //手机类型
    };
  },
  created() {
    document.title = "转岗申请";
  },
  async mounted() {
    this.commonId = getURLParam("commonId");
     this.setShowLoad(false); //加载状态，默认为true加载
    // this.postList = await getDictList(this.postCode);
    // this.departmentList = await getDepartment();
    this.$nextTick(() => {
     
      // this.selectDepartment();
      // console.log(this.postId)
      // if (this.postId) {
      //   console.log(111111)
      //   this.initPage();
      // }
    });
  },
  components: {
    refreshPage
  },
  methods: {
     ...mapMutations(["setShowLoad"]),
    initPage() {
      let _this = this;
     
      _this.$api.userLeavePost
        .details(this.postId)
        .then(res => {
          if (res.code == "1") {
            console.log(res.data)
          } else {
            console.log(res.msg);
            _this.postList = [];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveAssign() {
      let _this = this;
      _this.$api.userLeavePost
        .leaveApply({ parentCode: "gangwei" })
        .then(res => {
          if (res.code == "1") {
            _this.postList = res.data;
            console.log(JSON.stringify(_this.postList));
          } else {
            console.log(res.msg);
            _this.postList = [];
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    savePost(data) {
      this.upPost = data.dictName;
      this.showPostPicker = false;
    },
    saveDepartment(data) {
      this.upDepartment = data.departmentName;
      this.showDepartmentPicker = false;
    },
    TimePicker() {
      let _this = this;
      _this.showTimePicker = true;
    },
    onTimeConfirm(data) {
      //选择时间回调
      this.showTimePicker = false;
      this.startDate = dateFormat(data);
    },
    closeTimePicker() {
      this.showTimePicker = false;
    },
    myformate(time) {
      //格式化时间
      let str = time + "";
      let index = str.indexOf("GMT");
      return index > 0 ? dateFormat(time) : time.substring(0, 10);
    }
  },
  computed: {
   ...mapState(["showLoad", "userinfo"])
  },
  watch: {
    userinfo: {
      handler: function() {
        
      },
      deep: true
    }
  }
};
</script>
<style lang="less">
.assignPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  padding-top: 12px;
   
  .summaryBox {
    padding: 10px;
    margin-bottom: 50px;

    .readonlyInpt {
      padding: 0;
    }
    .readonlyInpt.van-cell:not(:last-child)::after {
      content: none;
    }
    .summary {
      padding-top: 0;
    }
    .summary.van-cell--required::before {
      top: -23px;
    }
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 45px;
    position: fixed;
    left: 0;
    bottom: 14px;
    .btn {
      display: block;
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      background-color: #3c78f9;
      color: #fff;
      font-size: 16px;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
    }
  }
}
</style>